module.exports = __webpack_public_path__ + "static/media/Planetary.d22faff3.jpeg";